/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3QvdmlkZW8tY2FsbC92aWRlby1jYWxsLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcXVhbmhvYW5nL3plbmlmeS9yZXBvcy9jbGllbnQtZmluYWwvc3JjL2FwcC9wYWdlcy9hZG1pbi9pY29udGFjdC92aWRlby1jYWxsL3ZpZGVvLWNhbGwuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/video-call/video-call.component.css.shim.ngstyle.ts